import { Component } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { User } from '@tminc/shared/data-models';
import { UserService } from '@services/user.service';
import { UserRoles } from '@tminc/data-access-user';
import { filter, map, startWith, tap } from 'rxjs/operators';
import { MainMenu, SettingsMenu } from './toolbar-menu';

@Component({
    selector: 'app-shell',
    templateUrl: './shell.component.html',
})
export class ShellComponent {
    mainMenu;
    settingsMenu;
    isPromoter$; // used in MainMenu descriptor
    notPromoter$; // used in MainMenu descriptor

    constructor(public userService: UserService, public auth: AngularFireAuth) {
        this.isPromoter$ = this.userService.user$.pipe(
            filter((user: User) => user?.roles?.includes(UserRoles.Promoter)),
        );
        this.notPromoter$ = this.isPromoter$.pipe(
            map((user) => {
                return !Boolean(user);
            }),
            startWith(true),
        );
        this.mainMenu = MainMenu(this);
        this.settingsMenu = SettingsMenu(this);
    }

    logout() {
        this.userService.logout();
    }
}
